<template>
  <v-card>
    <v-card-title> Specific donations </v-card-title>
    <v-card-text>
      <div v-if="testator.specificDonations.length">
        <ul>
          <li
            v-for="donation in testator.specificDonations"
            :key="'Donation' + donation.id"
          >
            <span v-if="donation.donationType == 'ASSET'">
              {{ donation.assetDisplayName }}
            </span>
            <span v-if="donation.donationType == 'MONEY'">
              {{ currencySymbol }} {{ donation.monetaryAmount | currency }}
            </span>
            <b>to</b> {{ beneficiariesText(donation) }}
          </li>
        </ul>
      </div>
      <p v-else-if="testator.specificDonationsOptOut">
        Opted out of specific donations
      </p>
      <p v-else>No specific donations and not opted out</p>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'SpecificDonationsCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    computed: {
      isGBWill() {
        return this.testator.willCountry == 'GB';
      },
      currencySymbol() {
        return this.isGBWill ? '£' : 'R';
      },
    },
    methods: {
      beneficiariesText(donation) {
        var text = '';
        donation.beneficiaries.forEach((beneficiary, index) => {
          if (index == 0) {
            text += this.beneficiaryText(beneficiary);
          } else if (donation.beneficiaries.length > index + 1) {
            text += ', ' + this.beneficiaryText(beneficiary);
          } else if (donation.beneficiaries.length == index + 1) {
            text += ' and ' + this.beneficiaryText(beneficiary);
          }
        });
        return text;
      },
      beneficiaryText(beneficiary) {
        var text = beneficiary.beneficiaryDisplayName;
        if (beneficiary.beneficiaryKinship) {
          text += ' - ' + beneficiary.beneficiaryKinship;
        }

        return text;
      },
    },
  };
</script>
